module.exports = function() {
  return new Worker(__webpack_public_path__ + "f984049c454681137d52.worker.js");
};